import React from 'react';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { ReactComponent as Logo } from './closeIcon.svg';

import AdChoices from './AdChoices';
import Browser from '../util/Browser';
import Color from '../util/Color';

import CloseGate from '../util/CloseGate';
const closeGate = new CloseGate(window);

class HeaderBar extends React.Component {

  flatButton = {
    border: 'none',
    margin: '0',
    padding: '0',
    width: 'auto',
    overflow: 'visible',
    background: 'transparent',
    color: 'inherit',
    font: 'inherit',
    lineHeight: 'normal',
    WebkitFontSmoothing: 'inherit',
    MozOsxFontSmoothing: 'inherit',
    WebkitAppearance: 'none',
  };

  getInitialState = () => ({
    // styles
    width: 0,
    height: 0,

    defaults: {
      locationIcon: {
        bgLight: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60' fill='%23434343'%3E%3Ccircle cx='30.011' cy='23.11' r='5.972'/%3E%3Cpath d='M30 0C13.43 0 0 13.432 0 30s13.43 30 30 30 30-13.43 30-30S46.57 0 30 0zm.56 53.367a.69.69 0 0 1-1.094 0c-.616-.794-15.1-19.553-15.1-29.41 0-8.623 7.014-15.638 15.637-15.638S45.65 15.333 45.65 23.956c-.001 9.858-14.474 28.617-15.1 29.41z'/%3E%3C/svg%3E`,
        bgDark: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='60' height='60' fill='%23fff'%3E%3Ccircle cx='30.011' cy='23.11' r='5.972'/%3E%3Cpath d='M30 0C13.43 0 0 13.432 0 30s13.43 30 30 30 30-13.43 30-30S46.57 0 30 0zm.56 53.367a.69.69 0 0 1-1.094 0c-.616-.794-15.1-19.553-15.1-29.41 0-8.623 7.014-15.638 15.637-15.638S45.65 15.333 45.65 23.956c-.001 9.858-14.474 28.617-15.1 29.41z'/%3E%3C/svg%3E`,
      },
      modalLeftArrow: {
        bgLight: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='34'%3E%3Cpath fill='%23434343' d='M10.475 32.383l-9.18-14.688a1.314 1.314 0 0 1 0-1.392l9.18-14.686a1.32 1.32 0 0 1 1.813-.418c.615.385.802 1.196.418 1.812L3.958 17l8.746 14a1.314 1.314 0 0 1-.418 1.81 1.3 1.3 0 0 1-.695.2 1.32 1.32 0 0 1-1.116-.617z'/%3E%3C/svg%3E`,
        bgDark: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='34'%3E%3Cpath fill='%23fff' d='M10.475 32.383l-9.18-14.688a1.314 1.314 0 0 1 0-1.392l9.18-14.686a1.32 1.32 0 0 1 1.813-.418c.615.385.802 1.196.418 1.812L3.958 17l8.746 14a1.314 1.314 0 0 1-.418 1.81 1.3 1.3 0 0 1-.695.2 1.32 1.32 0 0 1-1.116-.617z'/%3E%3C/svg%3E`,
      },
      closeIcon: {
        bgLight: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30'%3E%3Cpath fill='%23434343' d='M15.032 16.928L3.393 28.566a1.35 1.35 0 0 1-1.986-.001c-.552-.55-.552-1.323.055-1.93L13.1 14.996 1.407 3.304c-.552-.553-.552-1.324.055-1.93.442-.44 1.324-.55 1.875 0L15.03 13.066 26.725 1.374c.44-.442 1.322-.552 1.875 0s.495 1.5.056 1.93L16.962 14.998 28.6 26.636c.552.55.497 1.488.056 1.93a1.35 1.35 0 0 1-1.987-.001L15.032 16.928z'/%3E%3C/svg%3E`,
        bgDark: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30'%3E%3Cpath fill='%23fff' d='M15.032 16.928L3.393 28.566a1.35 1.35 0 0 1-1.986-.001c-.552-.55-.552-1.323.055-1.93L13.1 14.996 1.407 3.304c-.552-.553-.552-1.324.055-1.93.442-.44 1.324-.55 1.875 0L15.03 13.066 26.725 1.374c.44-.442 1.322-.552 1.875 0s.495 1.5.056 1.93L16.962 14.998 28.6 26.636c.552.55.497 1.488.056 1.93a1.35 1.35 0 0 1-1.987-.001L15.032 16.928z'/%3E%3C/svg%3E`,
      },
      appIconBorder: {
        bgLight: '#c2c2c2',
        bgDark: '#ffffff',
      },
      closeArrow: {
        bgLight: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='34'%3E%3Cpath fill='%23434343' d='M2.41 33a1.3 1.3 0 0 1-.695-.2 1.313 1.313 0 0 1-.418-1.81l8.746-14L1.295 3.01a1.315 1.315 0 0 1 2.23-1.393l9.18 14.686c.266.426.266.967 0 1.393l-9.18 14.687c-.25.398-.68.617-1.116.617z'/%3E%3C/svg%3E`,
        bgDark: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14' height='34'%3E%3Cpath fill='%23fff' d='M2.41 33a1.3 1.3 0 0 1-.695-.2 1.313 1.313 0 0 1-.418-1.81l8.746-14L1.295 3.01a1.315 1.315 0 0 1 2.23-1.393l9.18 14.686c.266.426.266.967 0 1.393l-9.18 14.687c-.25.398-.68.617-1.116.617z'/%3E%3C/svg%3E`,
      },
    },
    closeSpinner: `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='36' height='36' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid' fill='%23f0f0f0'%3E%3Crect x='46.5' y='40' width='7' height='20' rx='5' transform='translate(0 -30)'%3E%3Canimate attributeName='opacity' from='1' to='0' dur='1s' begin='0s' repeatCount='indefinite'/%3E%3C/rect%3E%3Crect x='46.5' y='40' width='7' height='20' rx='5' transform='rotate(30 105.98 65)'%3E%3Canimate attributeName='opacity' from='1' to='0' dur='1s' begin='0.08333333333333333s' repeatCount='indefinite'/%3E%3C/rect%3E%3Crect x='46.5' y='40' width='7' height='20' rx='5' transform='rotate(60 75.98 65)'%3E%3Canimate attributeName='opacity' from='1' to='0' dur='1s' begin='0.16666666666666666s' repeatCount='indefinite'/%3E%3C/rect%3E%3Crect x='46.5' y='40' width='7' height='20' rx='5' transform='rotate(90 65 65)'%3E%3Canimate attributeName='opacity' from='1' to='0' dur='1s' begin='0.25s' repeatCount='indefinite'/%3E%3C/rect%3E%3Crect x='46.5' y='40' width='7' height='20' rx='5' transform='rotate(120 58.66 65)'%3E%3Canimate attributeName='opacity' from='1' to='0' dur='1s' begin='0.3333333333333333s' repeatCount='indefinite'/%3E%3C/rect%3E%3Crect x='46.5' y='40' width='7' height='20' rx='5' transform='rotate(150 54.02 65)'%3E%3Canimate attributeName='opacity' from='1' to='0' dur='1s' begin='0.4166666666666667s' repeatCount='indefinite'/%3E%3C/rect%3E%3Crect x='46.5' y='40' width='7' height='20' rx='5' transform='rotate(180 50 65)'%3E%3Canimate attributeName='opacity' from='1' to='0' dur='1s' begin='0.5s' repeatCount='indefinite'/%3E%3C/rect%3E%3Crect x='46.5' y='40' width='7' height='20' rx='5' transform='rotate(-150 45.98 65)'%3E%3Canimate attributeName='opacity' from='1' to='0' dur='1s' begin='0.5833333333333334s' repeatCount='indefinite'/%3E%3C/rect%3E%3Crect x='46.5' y='40' width='7' height='20' rx='5' transform='rotate(-120 41.34 65)'%3E%3Canimate attributeName='opacity' from='1' to='0' dur='1s' begin='0.6666666666666666s' repeatCount='indefinite'/%3E%3C/rect%3E%3Crect x='46.5' y='40' width='7' height='20' rx='5' transform='rotate(-90 35 65)'%3E%3Canimate attributeName='opacity' from='1' to='0' dur='1s' begin='0.75s' repeatCount='indefinite'/%3E%3C/rect%3E%3Crect x='46.5' y='40' width='7' height='20' rx='5' transform='rotate(-60 24.02 65)'%3E%3Canimate attributeName='opacity' from='1' to='0' dur='1s' begin='0.8333333333333334s' repeatCount='indefinite'/%3E%3C/rect%3E%3Crect x='46.5' y='40' width='7' height='20' rx='5' transform='rotate(-30 -5.98 65)'%3E%3Canimate attributeName='opacity' from='1' to='0' dur='1s' begin='0.9166666666666666s' repeatCount='indefinite'/%3E%3C/rect%3E%3C/svg%3E`,

    backgroundColor: '#434343',

    // APP COLORS
    // backgroundColor: '#F5F5F5', // light - buymeapie
    // backgroundColor: '#24AEC3', // dark  - checkpoints
    // backgroundColor: '#1CAAEB', // dark  - coupon sherpa
    // backgroundColor: '#F5412F', // dark  - epicurious
    // backgroundColor: '#09567C', // dark  - favado
    // backgroundColor: '#2962AC', // dark  - scanlife
    // backgroundColor: '#6C441E', // dark  - listease
    // backgroundColor: '#FFFFFF', // light - swagbucks
    // backgroundColor: '#4A1444', // dark  - viggle
    // backgroundColor: #f88c06, // - AT&T Code Scanner
    // backgroundColor: #fbe375. // - The Coupons App

    modalBannerColor: 'rgba(255, 255, 255, 0)',
    modalOpacity: '0',
    modalDisplay: 'none',
    modalTransitionDuration: '500ms',
    modalClosePointerEvents: 'auto',

    cardsHaveLoaded: false,
    clickClosed: false,
  });

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  componentWillReceiveProps(nextProps) {
    if (
      (!this.state.headerBarState && nextProps.headerBarState) ||
      (!this.props.headerBarState && nextProps.headerBarState)
    ) {
      const { headerBarState } = nextProps;
      const { defaults } = this.state;

      const isDark = Color.isDark(headerBarState.backgroundColor);
      const luma = isDark ? 'bgDark' : 'bgLight';

      // Defaults
      headerBarState.color = isDark ? '#ffffff' : '#434343';
      headerBarState.closeIcon = defaults.closeIcon[luma];
      headerBarState.locationIcon = defaults.locationIcon[luma];
      headerBarState.modalLeftArrow = defaults.modalLeftArrow[luma];
      headerBarState.appIconBorder = defaults.appIconBorder[luma];
      headerBarState.closeArrow = defaults.closeArrow[luma];
      // overrides
      if (
        get(nextProps, 'fields.engagement_visible') &&
        parseInt(nextProps.fields.engagement_visible, 10)
      ) {
        headerBarState.locationIcon = `/img/locations/${nextProps.fields.chain_id}.png`;
      }

      this.setState(headerBarState, this.setStyles);
    }

    // Modal is being deprecated
    if (nextProps.modalModel.state === 'show') {
      this.showModalBanner(nextProps);
    } else if (nextProps.modalModel.state === 'hide') {
      this.hideModalBanner();
    }
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    this.checkCloseGateProps(nextProps, this.props, nextState, this.state);
    return true;
  }

  componentDidMount() {
    window.addEventListener('message', this.postMessageReceiver);
  }

  componentWillUmount() {
    window.removeEventListener('message', this.postMessageReceiver);
  }

  componentDidUpdate() {
    this.checkCloseGateProps(this.props, this.props, this.state, this.state);
  }

  checkCloseGateProps = (nextProps, props, nextState, state) => {
    // cardsHaveLoaded is once we've seen iframe_loaded or iframe_loaded_dfp messages.
    if (nextState.cardsHaveLoaded || state.cardsHaveLoaded) {
      // kills the 10s timeout and starts a 5s count-down from the appDisplayed call.
      closeGate.engagementDisplaying(this.closeIfClicked);
    } // didFinishAnimation is the scroll up animation... doesn't happen on 2nd ad, so required unnesting.
    else if (nextProps.didFinishAnimation || props.didFinishAnimation) {
      closeGate.appDisplaying(this.closeIfClicked);
    }
  };

  /**
   * Used both as the onClick function.
   *
   * @param e The clicked element... only here because we use this as an onClick function.
   * @param force This is used at the end of execCloseDelay,
   *              when close has been clicked and we were timing out,
   *              or in the postMessageReceiver, in a special case for Sizmek.
   * @returns {boolean}
   */
  onClickClose = (e, force = false) => {
    const { doClose, adsControl } = this.props;
    try {
      //console.log(`onClickClose() clk - ${e.clientX}, ${e.clientY}`);
      if (e && e.touches && e.touches.length > 0) {
        console.log(`onClickClose() tch - ${e.touches[0].clientX}, ${e.touches[0].clientY}`);
      }
    } catch(err) {
      console.log('onClickClose() err', err);
    }
    // followup handled by shouldComponentUpdate(), then also used in render for the spinner
    this.setState({ clickClosed: true });
    if (
      // when the env is development and we're not using mock-m2m, then don't wait
      Browser.isLocal()
      // would have been set at the end of our delay/timeouts.
      || closeGate.closeEnabled
      // immediately close the engagement, as our timeouts have ended anyways (or it's a special case)
      || force
      // immediately close the engagement, and the spinner will occur on the survey.
      || adsControl.hasANextAd()
    ) {
      console.log('headerBar.onClickClose - actually closing', force);
      // actually close the engagement.  just sets state in the engagement app to { open: false }
      doClose();
    } else {
      console.log('headerBar.onClickClose - just setting styles', force);
      this.setStyles();
      closeGate.closeClicked(doClose);
    }
    return true;
  };

  closeIfClicked = () => {
    // this is fine, because onClickClose is also the event handler for the close button.
    if (this.state.clickClosed === true) {
      this.onClickClose(null, true);
    }
  };

  onClickHideModal = () => {
    this.props.disableModal();
  };

  setStyles = () => {
    const iconHeight = 35;
    const iconWidth = 35;
    const imageStyle = {
      // backgroundSize: '60px 60px',
      width: iconWidth,
      height: iconHeight,
      cursor: 'pointer',
    };

    const paddingTop = Browser.getTopPadding();
    const {
      closeIcon,
      appIcon,
      closeArrow,
      appIconBorder,
      closeSpinner,
      backgroundColor,
      color,
      width,
      height,
      locationIcon,
      modalBannerColor,
      modalDisplay,
      modalOpacity,
      modalTransitionDuration,
      modalLeftArrow,
      modalClosePointerEvents,
    } = this.state;

    const iconStyle = {
      ...imageStyle,
    };
    let closeWrapperStyle = {
      padding: 10,
      paddingBottom: 0,
      marginBottom: 10,
      top: -10,
      zIndex: 9,
      float: 'right',
      position: 'relative',
    };
    let closeStyle = {
      ...iconStyle,
      background: `url("${closeIcon}") no-repeat right center`,
      backgroundSize: '25px 25px',
      float: 'right',

      // lineHeight: '40px',
      marginTop: '5px',

      height: '25px',
      width: '25px',
    };
    if (typeof appIcon !== 'undefined') {
      closeWrapperStyle = {
        ...closeWrapperStyle,
        background: `url("${closeArrow}") no-repeat right center`,
        backgroundSize: '12px 25px',

        // width: 80,
        margin: '-1px 10px 0px 0px',
      };
      closeStyle = {
        ...closeStyle,
        background: `url("${appIcon}") no-repeat center center`,
        backgroundSize: '35px 35px',
        border: `solid 2px ${appIconBorder}`,
        borderRadius: '8px',
        margin: '0px 14px 0 10px',
        height: 35,
        width: 35,
      };
    }
    const { clickClosed } = this.state;
    if (!closeGate.closeEnabled && clickClosed) {
      closeStyle = {
        ...closeStyle,
        background: `url("${closeSpinner}") no-repeat center center`,
        width: 35,
        height: 35,
        marginTop: '0px',
      };
    }

    // Includes top padding for iPhoneX.
    const headerNodeStyle = {
      backgroundColor,
      boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
      color,
      fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
      fontSize: 22,
      fontWeight: '300',
      width: '100%',
      height,
      position: 'fixed',
      zIndex: Number.MAX_SAFE_INTEGER,
      paddingTop: `${paddingTop}px`,
    };

    const logoStyle = {
      ...imageStyle,
      background: `url("${locationIcon}") no-repeat center`,
      backgroundSize: 'contain',
      borderRadius: '20px',
      float: 'left',
      margin: '-1px 0px 0 10px',
      width: 39,
      height: 39,
      zIndex: 9,
    };
    const labelStyle = {
      lineHeight: '35px',
      margin: '0px 0px 0 10px',
      float: 'left',
      overflow: 'hidden',
      width: width - iconWidth * 3 - 40,
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    };

    const modalBannerStyle = {
      backgroundColor: modalBannerColor,
      color: '#ffffff',
      display: modalDisplay,
      fontFamily: `-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
      fontSize: 18,
      fontWeight: '300',
      width,
      height,
      opacity: modalOpacity,
      position: 'fixed',
      textAlign: 'center',
      zIndex: 600,

      transitionProperty: 'opacity background-color',
      WebkitTransitionProperty: 'opacity background-color',
      transitionDuration: modalTransitionDuration,
      WebkitTransitionDuration: modalTransitionDuration,
    };
    const modalBackStyle = {
      background: `url("${modalLeftArrow}") no-repeat left center`,
      backgroundSize: '11px 25px',
      height: 25,
      width: 27,
      cursor: 'pointer',
      float: 'left',
      margin: '4px 0 0 10px',
      position: 'relative',
      pointerEvents: modalClosePointerEvents,
    };

    this.setState({
      closeStyle,
      headerNodeStyle,
      logoStyle,
      labelStyle,
      modalBannerStyle,
      modalBackStyle,
      closeWrapperStyle,
    });
  };

  hideModalBanner = () => {
    this.setState({
      modalOpacity: '0',
    });
    this.hideModalBannerTimeout = setTimeout(() => {
      this.hideModalBannerTimeout = null;
        console.log('HeaderBar - hideModalBannerTimeout firing');
      this.setState({
        modalDisplay: 'none',
      });
    }, 1000);
  };

  /**
   * If the user clicks the close button but the code that fires
   * the pixel has not loaded, we want to wait for a bit.
   * Pause until the js file has loaded or 5 seconds, whichever is less.
   * Listen for postMessag MessageEvent fired from third_party_impr_pels.js
   */
  postMessageReceiver = evt => {
    // Allow messages from Sizmek
    try {
      const msg = JSON.parse(evt.data);
      if (msg.type === 'ebCollapsePanel') {
        console.log(
          'This is a special Sizmek ad and someone closed it, so we are closing E2 as well'
        );
        this.onClickClose(null, true);
        return;
      }
    } catch (e) {
      return;
    }

    // Do we trust the sender of this message?
    // (might be from another host, for example).
    const isDFP = get(evt, 'data', '').indexOf('iframe_loaded_dfp') !== -1;
    if (!evt.data || (typeof evt.data === 'string' && !evt.data.match(/"m2m_impr_id"/))) {
      // DFP won't send m2m_impr_id, so don't quit if it's just DFP saying we're loaded
      if (!isDFP) {
        window.server.log({
          fn: 'HeaderBar.postMessageReceiver',
          tag: 'HEADER_MSG_INVALID',
          msg: `Not processing postMessage.  Invalid data: ${evt.data}`,
          evt,
        });
        return;
      }
    }

    let data = {};
    const stringData = typeof evt.data === 'object' ? JSON.stringify(evt.data) : evt.data;
    if (typeof stringData !== 'string' || stringData.indexOf('react-devtools') !== -1) {
      return;
    }

    try {
      // 'data' is a custom object created in the postMessage sender in third_party_impr_pel.js
      // JSON.parse will throw an exception if the data is invalid json and trigger excessive logging.
      // google calls postMessage with invalid json multiple times, so don't parse them if they do.
      if (stringData.indexOf('goog_') === -1 && typeof evt.data.googMsgType === 'undefined') {
        try {
          data = JSON.parse(stringData);
        } catch (e) {
          if (!isEmpty(evt.data)) {
            window.server.log({
              msg: 'invalid json detected',
              tag: 'HEADER_JSON_INVALID',
              data: evt.data,
            });
          }
        }
      } else {
        return;
      }

      // at this point the cards have loaded
      if (data.action === 'iframe_loaded' || data.action === 'iframe_loaded_dfp') {
        console.log(`HeaderBar.postMessageReceiver() received message from ${evt.origin}`, evt);
        this.setState({ cardsHaveLoaded: true });
      }
    } catch (err) {
      console.log('HeaderBar.postMessageReceiver() error: ', err);
    }
  };

  showModalBanner = nextProps => {
    console.log('showModalBanner');
    const color = Color.extractRgb(this.state.backgroundColor);
    this.setState({
      modalDisplay: 'block',
      modalClosePointerEvents: 'none',
    });
    this.showModelBannerTimeout = setTimeout(() => {
      this.showModelBannerTimeout = null;
      console.log('HeaderBar - showModelBannerTimeout firing');
      this.setState({
        modalBannerColor: `rgba(${color.r}, ${color.g}, ${color.b}, 1)`,
        modalOpacity: '1',
        modalClosePointerEvents: 'auto',
      });
    }, 100);
  };

  render() {
    const isCeltra = get(this.props, 'ad.html', '').includes('celtra') || this.props.isCeltra;

    // Determine if we need to show AdChoices; we show it after animmation is finished.
    // Assume animation is finished if null value is passed in for didFinishLoadAnimation (for when there is no animation)
    // eg. ads after the 1st ad in a multiple ad scenario.
    const adChoices = get(this.props, 'headerBarState.adChoices', false);
    const didFinishAnimation = get(this.props, 'didFinishLoadAnimation', true);
    const isShowAdChoices = adChoices && didFinishAnimation;

    const chainName = get(this.props, 'fields.chain_name', '');
    const {
      headerNodeStyle,
      modalBannerStyle,
      modalBackStyle,
      logoStyle,
      labelStyle,
      closeWrapperStyle,
      closeStyle,
    } = this.state;
    const { closeSpinner, clickClosed } = this.state;
    return !isCeltra ? (
      <div style={headerNodeStyle}>
        {isShowAdChoices && <AdChoices />}
        <div style={modalBannerStyle}>
          <div
            style={{
              marginTop: 14,
            }}
          >
            <button
              type="button"
              style={{ ...this.flatButton, ...modalBackStyle }}
              onClick={this.onClickHideModal}
            />
          </div>
        </div>
        <div
          style={{
            marginTop: 8,
          }}
        >
          <div style={logoStyle} />
          <div data-test-id="e2-chain-name" style={labelStyle}>{chainName}</div>
          <button
            type="button"
            id="closeButton"
            name="closeButton"
            aria-label="closeButton"
            style={{ ...this.flatButton, ...closeWrapperStyle }}
            onTouchStart={this.onClickClose}
            onClick={this.onClickClose}
          >

            <div data-test-id={clickClosed ? 'close-spinner' : 'close-circle'} style={closeStyle} />
          </button>
        </div>
      </div>
    ) : (
      <div
        style={{
          ...headerNodeStyle,
          boxShadow: 'inherit',
          borderColor: 'transparent',
          backgroundColor: 'transparent',
        }}
      >
        {isShowAdChoices && <AdChoices isCeltra />}
        <div
          style={{
            marginTop: 8,
          }}
        >
          <button
            type="button"
            id="closeButton"
            name="closeButton"
            className="close-button-celtra"
            aria-label="closeButton"
            style={{ ...this.flatButton, ...closeWrapperStyle, outline: 'none' }}
            onTouchStart={this.onClickClose}
            onClick={this.onClickClose}
          >
            {clickClosed ? (
              <div
                style={{
                  ...closeStyle,
                  height: '36px',
                  width: '36px',
                  outline: 'none',
                  background: `url("${closeSpinner}") no-repeat center center`,
                }}
              />
            ) : (
              <span
                data-test-id="close-circle"
                role="img"
                aria-label="close-circle"
                className="anticon anticon-close-circle"
              >
                <Logo style={{ outline: 'none' }} />
              </span>
            )}
          </button>
        </div>
      </div>
    );
  }
}

export default HeaderBar;
